import {
  ADD_MORE_CARS,
  INCREMENT_PAGE,
  RESET_PAGE
} from "@/store/mutationTypes";

export default {
  [ADD_MORE_CARS](state, cars) {
    state.carList = [...state.carList, ...cars];
  },

  [INCREMENT_PAGE](state) {
    state.currentPage++;
  },

  [RESET_PAGE](state) {
    state.carList = [];
    state.nextPage = "";
    state.currentPage = 1;
  }
};
